import React, { useContext, useEffect, useState } from "react";
import UserContext from "../../contexts/UserContext";
import Utils from "../../Utils";
import _ from "lodash";

const HrNotifications = (props) => {
  const { userData } = useContext(UserContext);
  const [open, setOpen] = useState(false);


  return (
    <>
    <div class="dashboard-section">
            <div class="section-title">
                <i class="fas fa-bell"></i>
                Notifications
            </div>
            <div class="space-y-3">
                <div class="notification-item p-4 rounded-lg flex items-center justify-between">
                    <div class="flex items-center space-x-4">
                        <i class="fas fa-camera text-2xl text-gray-600"></i>
                        <div>
                            <p class="font-semibold text-gray-800">Photoshoot Update</p>
                            <p class="text-sm text-gray-600">Update by Photographer 1</p>
                        </div>
                    </div>
                    <span class="text-xs text-gray-500">2 hours ago</span>
                </div>
            </div>
        </div>
    </>
  );
};

export default HrNotifications;
